import styled from 'styled-components'

export const OptionWrapper = styled.div`
  font-size: 14px;
  padding: 16px 0px;
  border-bottom: 1px solid #d9d9d9;
  input {
    width: 104px;
    height: 40px;
    margin-top: 5px;
  }
`

export const Option = styled.div`
  display: flex;
  justify-content: space-between;
  span {
    color: #363636;
    font-weight: 700;
    display: flex;
    align-items: center;
    span {
      color: #757575;
      margin-left: 4px;
    }
  }
`

export const Content = styled.div`
  width: calc(100% - 128px);
`

export const Title = styled.div`
  color: #363636;
  font-weight: 500;
`

export const Description = styled.div`
  color: #757575;
  margin-top: 6px;
`

export const Alert = styled.div`
  border: 1px solid #b6dbfb;
  background-color: #e7f3fe;
  color: #363636;
  padding: 8px;
  border-radius: 8px;
  margin-top: 16px;
  svg {
    color: #213f68;
    margin: 0px 4px;
    margin-right: 10px;
    font-size: 12px;
  }
`

export const Detail = styled.div`
  border-bottom: 1px solid #d9d9d9;
  margin-bottom: 16px;
`

export const DetailContent = styled.div`
  padding: 16px 24px;
  margin: 16px 0px;
  border-radius: 8px;
  background-color: #f5f5f5;
  display: flex;
  justify-content: space-between;
`
